var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/* eslint-disable no-unused-vars, class-methods-use-this, import/no-unresolved */
import { RequestLoggerPlugin } from '@itly/sdk';
/**
 * Segment Browser Plugin for Iteratively SDK
 */
var SegmentPlugin = /** @class */function (_super) {
  __extends(SegmentPlugin, _super);
  function SegmentPlugin(writeKey, options) {
    var _this = _super.call(this, 'segment') || this;
    _this.writeKey = writeKey;
    _this.options = options;
    return _this;
  }
  Object.defineProperty(SegmentPlugin.prototype, "segment", {
    get: function () {
      // eslint-disable-next-line no-restricted-globals
      var s = typeof self === 'object' && self.self === self && self;
      return s && s.analytics;
    },
    enumerable: false,
    configurable: true
  });
  SegmentPlugin.prototype.load = function (options) {
    _super.prototype.load.call(this, options);
    if (!this.segment) {
      this.loadSegment();
      this.segment.load(this.writeKey, this.options);
    }
  };
  SegmentPlugin.prototype.loadSegment = function () {
    // Segment (https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/)
    // @ts-ignore
    // eslint-disable-next-line
    !function () {
      var analytics = window.analytics = window.analytics || [];
      if (!analytics.initialize) if (analytics.invoked) window.console && console.error && console.error("Segment snippet included twice.");else {
        analytics.invoked = !0;
        analytics.methods = ["trackSubmit", "trackClick", "trackLink", "trackForm", "pageview", "identify", "reset", "group", "track", "ready", "alias", "debug", "page", "once", "off", "on", "addSourceMiddleware", "addIntegrationMiddleware", "setAnonymousId", "addDestinationMiddleware"];
        analytics.factory = function (t) {
          return function () {
            var e = Array.prototype.slice.call(arguments);
            e.unshift(t);
            analytics.push(e);
            return analytics;
          };
        };
        for (var t = 0; t < analytics.methods.length; t++) {
          var e = analytics.methods[t];
          analytics[e] = analytics.factory(e);
        }
        analytics.load = function (t, e) {
          var n = document.createElement("script");
          n.type = "text/javascript";
          n.async = !0;
          n.src = "https://cdn.segment.com/analytics.js/v1/" + t + "/analytics.min.js";
          var a = document.getElementsByTagName("script")[0];
          a.parentNode.insertBefore(n, a);
          analytics._loadOptions = e;
        };
        analytics.SNIPPET_VERSION = "4.1.0";
      }
    }();
  };
  SegmentPlugin.prototype.alias = function (userId, previousId, options) {
    var _a = options !== null && options !== void 0 ? options : {},
      callback = _a.callback,
      segmentOptions = _a.options;
    var responseLogger = this.logger.logRequest('alias', userId + ", " + previousId);
    this.segment.alias(userId, previousId, segmentOptions, this.wrapCallback(responseLogger, callback));
  };
  SegmentPlugin.prototype.identify = function (userId, properties, options) {
    var _a = options !== null && options !== void 0 ? options : {},
      callback = _a.callback,
      segmentOptions = _a.options;
    var responseLogger = this.logger.logRequest('identify', userId + ", " + JSON.stringify(properties));
    if (userId) {
      this.segment.identify(userId, properties, segmentOptions, this.wrapCallback(responseLogger, callback));
    } else {
      this.segment.identify(properties, segmentOptions, this.wrapCallback(responseLogger, callback));
    }
  };
  SegmentPlugin.prototype.group = function (userId, groupId, properties, options) {
    var _a = options !== null && options !== void 0 ? options : {},
      callback = _a.callback,
      segmentOptions = _a.options;
    var responseLogger = this.logger.logRequest('group', userId + ", " + groupId + ", " + JSON.stringify(properties));
    this.segment.group(groupId, properties, segmentOptions, this.wrapCallback(responseLogger, callback));
  };
  SegmentPlugin.prototype.page = function (userId, category, name, properties, options) {
    var _a = options !== null && options !== void 0 ? options : {},
      callback = _a.callback,
      segmentOptions = _a.options;
    var responseLogger = this.logger.logRequest('page', userId + ", " + category + ", " + name + ", " + JSON.stringify(properties));
    this.segment.page(category, name, properties, segmentOptions, this.wrapCallback(responseLogger, callback));
  };
  SegmentPlugin.prototype.track = function (userId, _a, options) {
    var name = _a.name,
      properties = _a.properties;
    var _b = options !== null && options !== void 0 ? options : {},
      callback = _b.callback,
      segmentOptions = _b.options;
    var responseLogger = this.logger.logRequest('track', userId + ", " + name + ", " + JSON.stringify(properties));
    this.segment.track(name, properties, segmentOptions, this.wrapCallback(responseLogger, callback));
  };
  SegmentPlugin.prototype.reset = function () {
    this.segment.reset();
  };
  SegmentPlugin.prototype.wrapCallback = function (responseLogger, callback) {
    return function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      responseLogger.success("done " + args);
      callback === null || callback === void 0 ? void 0 : callback.apply(void 0, args);
    };
  };
  return SegmentPlugin;
}(RequestLoggerPlugin);
export { SegmentPlugin };
export default SegmentPlugin;